import React from 'react';
import { Table, Card } from 'react-bootstrap';

const TablaConciliaciones = ({ conciliaciones }) => {
    // Si no hay conciliaciones, no mostramos nada
    if (!conciliaciones || conciliaciones.length === 0) {
        return null;
    }

    const formatNumberMX = (value) => {
        return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value || 0);
    };

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('es-MX');
    };

    return (
        <Card className="mt-4 mb-4 shadow-sm border-0 bg-light">
            <Card.Header className="bg-transparent border-0 pt-3 pb-0">
                <h6 className="m-0 text-secondary"><i className="bi bi-bank me-2"></i>Movimientos Bancarios Conciliados</h6>
            </Card.Header>
            <Card.Body>
                <Table responsive hover size="sm" className="m-0 bg-white shadow-sm rounded overflow-hidden">
                    <thead className="table-light text-secondary">
                        <tr>
                            <th className="fw-normal">Fecha del Movimiento</th>
                            <th className="fw-normal">Banco y Cuenta</th>
                            <th className="text-end fw-normal">Monto Conciliado</th>
                        </tr>
                    </thead>
                    <tbody>
                        {conciliaciones.map((c, idx) => (
                            <tr key={idx}>
                                <td className="align-middle">{formatDate(c.dFechaMovimiento)}</td>
                                <td className="align-middle text-muted">{c.vBanco}</td>
                                <td className="align-middle text-end fw-bold text-success">
                                    {formatNumberMX(c.dMontoConciliado)}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Card.Body>
        </Card>
    );
};

export default TablaConciliaciones;
